/* eslint-disable  */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ThemeOptions } from 'redux-store/channelTheme/channelTheme.interface'
import { useChannelTheme } from 'pages/ChannelPage/Theme/useChannelTheme'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import useCompanyParam from 'hooks/CompanyParam'
import { applyTheme } from 'pages/ChannelPage/Theme/applyTheme'

let lastTheme: ThemeOptions | undefined = undefined

export const useWithTheme = () => {
  const { channelTheme, channelThemeIsLoading } = useChannelTheme()
  const channel = useSelector(channelSelector)
  const company = useCompanyParam()
  useEffect(() => {
    const channelWithThemeReady =
      channel.data &&
      channelTheme &&
      channelTheme?.channelPrimaryColor! &&
      !channelThemeIsLoading
    const noChannelWithDefaultThemeReady =
      channelTheme?.channelPrimaryColor! && !channelThemeIsLoading && !company
    let themeChanged = true
    if (channelTheme && lastTheme) {
      try {
        themeChanged =
          JSON.stringify(channelTheme) !== JSON.stringify(lastTheme)
      } catch (e) {
        console.log(e)
      }
    }
    if (
      (channelWithThemeReady || noChannelWithDefaultThemeReady) &&
      themeChanged
    ) {
      applyTheme(channelTheme)
    }
    if (channelTheme && channelTheme?.channelPrimaryColor!) {
      lastTheme = channelTheme
    }
  }, [channelTheme, channelThemeIsLoading, channel, company])
}
